import { Container } from "../../UI/container/Container";
import { MyH1 } from "../../UI/my-h1/MyH1";
import { Card } from "@mantine/core";
import { useColors } from "../../../hooks/colors/useColors";
import { BlogShare } from "./BlogShare";
import { MoreEntries } from "./MoreEntries";
import { PageHeader } from "../page-header/PageHeader";
import Image from "next/image";
import { showLocalizedDate } from "../../../services/dateAndTime/dateAndTimeUtil";
import { useTranslation } from "next-i18next";
import { isMobile } from "react-device-detect";
import { ContentVisualizer } from "../content-visualizer/ContentVisualizer";
import { Fragment } from "react";
import { BlogDataProps } from "../../../hooks/react-query/useBlogList";
import { BlogAuthor } from "./BlogAuthor";
import { mobile, tablet } from "../../../constants/env";

export function BlogArticle(props: BlogDataProps) {
  const { blog } = props;
  const { colors } = useColors();
  const { i18n } = useTranslation("common");

  let imageClass = "p-0 flex relative w-[320px] h-[180px]";
  if (!mobile) imageClass = "p-0 flex relative w-[1152px] h-[648px]";
  if (tablet) imageClass = "p-0 flex relative w-[480px] h-[270px]";

  return (
      <Fragment>
        <PageHeader>
          <MyH1
              size={isMobile ? "1.8rem" : "2.6rem"}
              className="text-center"
              color="white"
          >
            {blog.title}
          </MyH1>
        </PageHeader>
        <Container noHeight>
          {blog.image && blog.image.length > 10 && (
              <div
                  className="flex justify-center"
                  style={{ marginTop: -50, marginBottom: 50 }}
              >
                <Card className={imageClass} radius="xs" shadow="md">
                  <Image
                      priority
                      alt="Person"
                      src={blog.image}
                      sizes="1152px 480px 320px"
                      fill
                      style={{
                        objectFit: "cover",
                      }}
                  />
                </Card>
              </div>
          )}
          <div className="my-8 text-center">
            <i className="text-2xl">
              {`${
                  !blog.specialistUrl ? blog.author + ", " : ""
              }${showLocalizedDate(blog.timestamp, i18n.language)}`}
            </i>
          </div>
          <ContentVisualizer content={blog.content} />
          <BlogAuthor authorSlug={blog.specialistUrl || ""} />
          <BlogShare blog={blog} />
          <MoreEntries entry={blog} />
        </Container>
      </Fragment>
  );
}

// import { Container } from "../../UI/container/Container";
// import { MyH1 } from "../../UI/my-h1/MyH1";
// import { Badge, Text } from "@mantine/core";
// import { BlogShare } from "./BlogShare";
// import { PageHeader } from "../page-header/PageHeader";
// import { useTranslation } from "next-i18next";
// import { isMobile } from "react-device-detect";
// import { ContentVisualizer } from "../content-visualizer/ContentVisualizer";
// import { Fragment, ReactNode } from "react";
// import { BlogAuthor } from "./BlogAuthor";
// import Link from "next/link";
// import { IconFolder, IconSlash, IconTag } from "@tabler/icons";
// import { Post, Tag } from "../../../types/graphql";
//
// import { MoreEntries } from "./MoreEntries";
// import { isPhone } from "../../../constants/env";
// import { Footer } from "../homepage/footer/Footer";
//
// export function BlogArticle({ blog }: { blog: Post }) {
//   const { i18n } = useTranslation("common");
//
//   const breadCrumbs: ReactNode[] = [
//     <Link href={`/blog`} key={0}>
//       <Text className="!text-blue-600">{i18n.t("blog.name")}</Text>
//     </Link>,
//     <Fragment key={1}>
//       {blog.categories && blog.categories.nodes.length > 0 && (
//         <Fragment>
//           {blog.categories.nodes.map((category) => {
//             if (!category.name?.includes("blog-pt"))
//               return (
//                 <div key={category.slug} className="flex items-center">
//                   <IconSlash />
//                   <Link href={`/blog/categoria/${category.slug}`}>
//                     <Text className="!text-blue-600">{category.name}</Text>
//                   </Link>
//                 </div>
//               );
//           })}
//         </Fragment>
//       )}
//     </Fragment>,
//   ];
//
//   return (
//     <Fragment>
//       <PageHeader height={isMobile ? 300 : 200}>
//         <MyH1
//           size={isMobile ? "1.8rem" : "3rem"}
//           className="text-center"
//           color="white"
//         >
//           {blog.title}
//         </MyH1>
//       </PageHeader>
//       <Container noHeight>
//         <div className="max-w-6xl mx-auto my-4">
//           <div className="flex">
//             <IconFolder className="!text-gray-500 mr-2" size={20} />
//             {breadCrumbs}
//           </div>
//         </div>
//
//         {blog.content && <ContentVisualizer content={blog.content} />}
//         <div className="max-w-6xl mx-auto my-4">
//           {blog.tags && blog.tags.nodes.length > 0 && (
//             <div className="xs:flex-col gap-2 lg:flex">
//               {blog.tags.nodes.map((tag: Tag, index) => {
//                 return (
//                   <div key={tag.id}>
//                     <Link href={`/blog/tag/${tag.slug}`} key={index}>
//                       <Badge>
//                         <div className="flex items-center gap-1">
//                           <IconTag className="!text-white" size={20} />
//                           {tag.name}
//                         </div>
//                       </Badge>
//                     </Link>
//                   </div>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//         <BlogAuthor blog={blog} />
//         <div className="w-full flex justify-center my-4 w-full">
//           {/*<Link*/}
//           {/*  className="flex gap-4 items-center"*/}
//           {/*  href={`/blog/categoria/${blog.category}`}*/}
//           {/*  style={{ textDecoration: "none" }}*/}
//           {/*>*/}
//           {/*  <Text color={colors.primary} className="!text-4xl">*/}
//           {/*    {i18n.t("blog.all-categories")}*/}
//           {/*  </Text>*/}
//           {/*  <IconArrowNarrowRight size="4rem" color={colors.primary} />*/}
//           {/*</Link>*/}
//         </div>
//         <BlogShare blog={blog} />
//         {/*<PostPagination blog={blog} />*/}
//         <MoreEntries post={blog} />
//       </Container>
//       {!isPhone && <Footer isVisible />}
//     </Fragment>
//   );
// }
